import { CancelOutlinedIcon, ErrorState } from '@shared/components';

export type AlternativeRegistrationErrorStateType =
  | 'user-blocked'
  | 'e-kyc-pending-approval'
  | 'user-absent'
  | 'user-canceled';

interface AlternativeRegistrationErrorStateProps {
  type: AlternativeRegistrationErrorStateType;
}

const ERROR_MESSAGES: Record<
  AlternativeRegistrationErrorStateType,
  { title: string; description: string }
> = {
  'user-blocked': {
    title: 'ผู้เข้าสอบถูกระงับสิทธิ์การสอบ',
    description: 'ไม่สามารถลงทะเบียนผู้เข้าสอบได้ เนื่องจากถูกระงับสิทธิ์การสอบ',
  },
  'e-kyc-pending-approval': {
    title: 'สถานะ e-KYC อยู่ระหว่างรอเจ้าหน้าที่ตรวจสอบ',
    description: 'กรุณาตรวจสอบข้อมูลการยืนยันตัวตน (e-KYC) ให้เรียบร้อย ก่อนดำเนินการต่อ',
  },
  'user-absent': {
    title: 'สิ้นสุดเวลาการลงทะเบียนผู้เข้าสอบ',
    description: 'เนื่องจากระบบไม่อนุญาตให้ลงทะเบียนผู้เข้าสอบ หลังเลยเวลาเริ่มสอบไปแล้ว 30 นาที',
  },
  'user-canceled': {
    title: 'ผู้เข้าสอบถูกยกเลิกรอบสอบ',
    description: 'ไม่สามารถลงทะเบียนผู้เข้าสอบได้ เนื่องจากการสอบถูกยกเลิก',
  },
};

export default function AlternativeRegistrationErrorState(
  props: Readonly<AlternativeRegistrationErrorStateProps>,
) {
  const { type } = props;

  if (!ERROR_MESSAGES[type]) {
    throw new Error(`Invalid error type: ${type}`);
  }

  return (
    <ErrorState
      icon={CancelOutlinedIcon}
      title={ERROR_MESSAGES[type].title}
      description={ERROR_MESSAGES[type].description}
      slotProps={{ wrapper: { disablePadding: true }, icon: { fontSize: 80, color: 'error' } }}
    />
  );
}
